import React, { Component } from 'react'
import { connect } from 'react-redux'

import { uploadImageMarkings } from '../../../actions/orders'

// import components
import Modal from '../../components/Modal'
import CircleImage from '../../components/CircleImage'

// Utils
import { translation } from '../../../utils/helpers'

import { ModalIcons } from '../../elements/icons'

class PhotoMarkModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false,
      image: null
    }
    this.submitImage = this.submitImage.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  componentDidMount () {
    let image = {...this.props.image}
    let url = image.realURL
    image.image = {
      imageUrl: url,
      circles: []
    }
    this.setState({
      image: image
    })
  }

  submitImage (image, update) {
    if (!update) return null
    let markings = []
    image.image.circles.map((circle) => {
      markings.push({
        PositionX: circle.left,
        PositionY: circle.top,
        Scale: parseFloat(circle.scale.toFixed(2)),
        Size: 50
      })
    })
    let imageMarkings = [
      {
        ImageSize: image.image.ImageSize,
        OrderFileID: image.OrderFileID || image.OrderFile.OrderFileID,
        Markings: markings
      }
    ]
    if (markings.length !== 0) {
      this.props.uploadImageMarkings(imageMarkings).then((res) => {
        // window.toastr.success(translation('2034'), translation('13424'))
        this.onClose(true)
      }, () => {
        window.toastr.error(translation('2035'), translation('216'))
      })
    } else {
      this.onClose(false)
    }
  }

  renderimage () {
    if (this.state.image === null) return null
    console.log('qweasd')
    return (
      <div>
        <CircleImage submitImage={this.submitImage} image={this.state.image} />
      </div>
    )
  }

  onClose (update) {
    this.props.onClose(update)
  }

  render () {
    let clickOutsideClose = false
    return (
      <div className='photomark__modal'>
        <Modal {...this.props} header={translation('2033')} overflowHidden={this.state.overflowHidden} clickOutsideClose={clickOutsideClose} onClose={this.onClose.bind(this, false)}
          icon={ModalIcons.Plus}>
          {this.renderimage()}
        </Modal>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  uploadImageMarkings
})(PhotoMarkModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/PhotoMarkModal/index.js